import { render, staticRenderFns } from "./fill_article.vue?vue&type=template&id=523ece2c&scoped=true"
import script from "./fill_article.vue?vue&type=script&lang=js"
export * from "./fill_article.vue?vue&type=script&lang=js"
import style0 from "./fill_article.vue?vue&type=style&index=0&id=523ece2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523ece2c",
  null
  
)

export default component.exports